export const isRestrictedSectorGap = (item) => (
  item?.kind === 'restricted-sector-gap'
);

export const isMessageItem = (item) => (
  Boolean(item) && !isRestrictedSectorGap(item)
);

export const normalizeMessagePageResponse = (response) => {
  if (Array.isArray(response)) {
    return {
      items: response,
      page: {
        nextOffset: response.length,
        hasMore: false,
      },
      access: {
        currentSectorRestricted: false,
        currentSectorName: null,
      },
    };
  }

  return {
    items: Array.isArray(response?.items) ? response.items : [],
    page: {
      nextOffset: Number.isInteger(response?.page?.nextOffset)
        ? response.page.nextOffset
        : 0,
      hasMore: Boolean(response?.page?.hasMore),
    },
    access: {
      currentSectorRestricted: Boolean(response?.access?.currentSectorRestricted),
      currentSectorName: response?.access?.currentSectorName || null,
    },
  };
};

export const mergeMessageItems = (currentItems = [], nextItems = []) => {
  const merged = [];
  const messageIds = new Set();

  [...currentItems, ...nextItems].forEach((item) => {
    if (isRestrictedSectorGap(item)) {
      if (!isRestrictedSectorGap(merged[merged.length - 1])) {
        merged.push(item);
      }
      return;
    }

    if (item?.id != null) {
      if (messageIds.has(item.id)) return;
      messageIds.add(item.id);
    }

    merged.push(item);
  });

  return merged;
};
